import { createFileRoute } from "@tanstack/react-router";
import { IntegrationDetail } from "@/pages/IntegrationDetail";
import { integrationPages } from "@/lib/integration-pages";
import { buildHead } from "@/lib/seo-head";

const page = integrationPages["escavador"];
if (!page) throw new Error("Integração não cadastrada");

export const Route = createFileRoute("/consulta-processos-ia-escavador")({
  head: () => buildHead({
    title: page.metaTitle,
    description: page.metaDescription,
    path: "/consulta-processos-ia-escavador",
  }),
  component: () => <IntegrationDetail integrationKey="escavador" />,
});
